<template>
  <v-dialog
    max-width="100%"
    class="graficos-dialog"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card class="mx-auto" color="grey lighten-4">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Curvas de crecimiento</v-toolbar-title>
      </v-toolbar>

      <v-tabs
        style="min-height: 300px"
        v-model="selectedTab"
        background-color="indigo"
        dark
      >
        <v-tab>Estatura</v-tab>
        <v-tab>Peso</v-tab>

        <v-tab-item>
          <v-card-title>
            <v-icon color="blue" class="mr-8" size="48">
              mdi-human-male-height
            </v-icon>
            <v-row align="start">
              <div>
                <h4>Estatura (cm.)</h4>
              </div>
            </v-row>
          </v-card-title>
          <v-sheet
            v-if="puntos0.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">0 - 6 meses (0 - 26 semanas)</h3>
            <line-chart
              :style="myStyle"
              :chartData="estaturaData0"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="puntos1.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">6 - 12 meses (27 - 52 semanas)</h3>
            <line-chart
              :style="myStyle"
              :chartData="estaturaData1"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="puntos2.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">1 - 3 años (12 - 35 meses)</h3>
            <line-chart
              :style="myStyle"
              :chartData="estaturaData2"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="puntos3.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">3 - 4 años (36 - 47 meses)</h3>
            <line-chart
              :style="myStyle"
              :chartData="estaturaData3"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="puntos4.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">4 - 14 años</h3>
            <line-chart
              :style="myStyle"
              :chartData="estaturaData4"
              :options="options"
            ></line-chart>
          </v-sheet>
          <v-alert
            v-if="
              !puntos0.length &&
              !puntos1.length &&
              !puntos2.length &&
              !puntos3.length &&
              !puntos4.length
            "
            class="mt-4"
            color="purple"
            dark
            outlined
          >
            No hay estaturas cargadas para el paciente en fechas cuyas edad era
            menor a 15 años.
          </v-alert>
        </v-tab-item>
        <v-tab-item>
          <v-card-title>
            <v-icon color="blue" class="mr-8" size="48"> mdi-scale </v-icon>
            <v-row align="start">
              <div>
                <h4>Peso (kg.)</h4>
              </div>
            </v-row>
          </v-card-title>
          <v-sheet
            v-if="pesos0.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">0 - 6 meses (0 - 26 semanas)</h3>
            <line-chart
              :style="myStyle"
              :chartData="pesoData0"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="pesos1.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">6 - 12 meses (27 - 52 semanas)</h3>
            <line-chart
              :style="myStyle"
              :chartData="pesoData1"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="pesos2.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">1 - 3 años (12 - 35 meses)</h3>
            <line-chart
              :style="myStyle"
              :chartData="pesoData2"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="pesos3.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">3 - 4 años (36 - 47 meses)</h3>
            <line-chart
              :style="myStyle"
              :chartData="pesoData3"
              :options="options"
            ></line-chart>
          </v-sheet>

          <v-sheet
            v-if="pesos4.length"
            class="v-sheet--offset mx-auto"
            color="transparent"
            elevation="12"
            max-width="100%"
          >
            <h3 style="padding: 2rem">4 - 14 años</h3>
            <line-chart
              :style="myStyle"
              :chartData="pesoData4"
              :options="options"
            ></line-chart>
          </v-sheet>
          <v-alert
            v-if="
              !pesos0.length &&
              !pesos1.length &&
              !pesos2.length &&
              !pesos3.length &&
              !pesos4.length
            "
            class="mt-4"
            color="purple"
            dark
            outlined
          >
            No hay pesos cargads para el paciente en fechas cuyas edad era menor
            a 15 años.
          </v-alert>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>
<script>
import LineChart from "./LineChart.js";
import {
  parametrosAlturaNina,
  parametrosPesoNina,
  parametrosPesoNino,
  parametrosAlturaNino,
  getAgeUnits,
  getRange,
  mapToX,
} from "./parametrosCrecimiento.js";
export default {
  components: { LineChart },
  data: (vm) => ({
    selectedTab: 0,

    maxWidth: "100%",

    estaturaData0: null,
    estaturaData1: null,
    estaturaData2: null,
    estaturaData3: null,
    estaturaData4: null,

    pesoData0: null,
    pesoData1: null,
    pesoData2: null,
    pesoData3: null,
    pesoData4: null,

    options: null,

    P30: [],
    P250: [],
    P500: [],
    P750: [],
    P970: [],

    P31: [],
    P251: [],
    P501: [],
    P751: [],
    P971: [],

    P32: [],
    P252: [],
    P502: [],
    P752: [],
    P972: [],

    P33: [],
    P253: [],
    P503: [],
    P753: [],
    P973: [],

    P34: [],
    P254: [],
    P504: [],
    P754: [],
    P974: [],

    PE30: [],
    PE250: [],
    PE500: [],
    PE750: [],
    PE970: [],

    PE31: [],
    PE251: [],
    PE501: [],
    PE751: [],
    PE971: [],

    PE32: [],
    PE252: [],
    PE502: [],
    PE752: [],
    PE972: [],

    PE33: [],
    PE253: [],
    PE503: [],
    PE753: [],
    PE973: [],

    PE34: [],
    PE254: [],
    PE504: [],
    PE754: [],
    PE974: [],

    parametrosAlturaNina,
    parametrosAlturaNino,
    parametrosPesoNina,
    parametrosPesoNino,

    puntos0: [],
    puntos1: [],
    puntos2: [],
    puntos3: [],
    puntos4: [],

    pesos0: [],
    pesos1: [],
    pesos2: [],
    pesos3: [],
    pesos4: [],
  }),
  props: ["visible", "signosVitales", "paciente"],
  computed: {
    myStyle() {
      return {
        height: "800px",
      };
    },
    show: {
      get() {
        if (this.$store.state.videollamada == true) this.maxWidth = "68%";
        else this.maxWidth = "100%";
        if (this.visible) {
          this.fillData();
        }

        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    vaciarModels() {
      this.selectedTab = 0;

      this.estaturaData0 = null;
      this.estaturaData1 = null;
      this.estaturaData2 = null;
      this.estaturaData3 = null;
      this.estaturaData4 = null;

      this.pesoData0 = null;
      this.pesoData1 = null;
      this.pesoData2 = null;
      this.pesoData3 = null;
      this.pesoData4 = null;

      this.puntos0 = [];
      this.puntos1 = [];
      this.puntos2 = [];
      this.puntos3 = [];
      this.puntos4 = [];

      this.pesos0 = [];
      this.pesos1 = [];
      this.pesos2 = [];
      this.pesos3 = [];
      this.pesos4 = [];
    },

    fillData() {
      const signosVitales = [...this.signosVitales.filter((sv) => sv.estatura)];

      console.log("signosVitales", signosVitales);

      signosVitales.forEach((sv) => {
        const ageUnits = getAgeUnits(this.paciente.fechaNac, sv.fechaHora);
        const range = getRange(ageUnits.months);
        switch (range) {
          case 0: {
            this.puntos0.push({
              x: mapToX(ageUnits, range),
              y: sv.estatura * 100,
            });

            this.pesos0.push({
              x: mapToX(ageUnits, range),
              y: sv.peso,
            });
            break;
          }
          case 1: {
            this.puntos1.push({
              x: mapToX(ageUnits, range),
              y: sv.estatura * 100,
            });
            this.pesos1.push({
              x: mapToX(ageUnits, range),
              y: sv.peso,
            });
            break;
          }
          case 2: {
            this.puntos2.push({
              x: mapToX(ageUnits, range),
              y: sv.estatura * 100,
            });
            this.pesos2.push({
              x: mapToX(ageUnits, range),
              y: sv.peso,
            });
            break;
          }
          case 3: {
            this.puntos3.push({
              x: mapToX(ageUnits, range),
              y: sv.estatura * 100,
            });
            this.pesos3.push({
              x: mapToX(ageUnits, range),
              y: sv.peso,
            });
            break;
          }
          case 4: {
            this.puntos4.push({
              x: mapToX(ageUnits, range),
              y: sv.estatura * 100,
            });
            this.pesos4.push({
              x: mapToX(ageUnits, range),
              y: sv.peso,
            });
            break;
          }
        }
      });

      // ALTURA

      const currentParametroAluta =
        this.paciente.sexo === "MASCULINO"
          ? this.parametrosAlturaNino
          : this.parametrosAlturaNina;
      this.P30 = currentParametroAluta["0"].P3;
      this.P250 = currentParametroAluta["0"].P25;
      this.P500 = currentParametroAluta["0"].P50;
      this.P750 = currentParametroAluta["0"].P75;
      this.P970 = currentParametroAluta["0"].P97;

      this.P31 = currentParametroAluta["1"].P3;
      this.P251 = currentParametroAluta["1"].P25;
      this.P501 = currentParametroAluta["1"].P50;
      this.P751 = currentParametroAluta["1"].P75;
      this.P971 = parametrosAlturaNina["1"].P97;

      this.P32 = currentParametroAluta["2"].P3;
      this.P252 = currentParametroAluta["2"].P25;
      this.P502 = currentParametroAluta["2"].P50;
      this.P752 = currentParametroAluta["2"].P75;
      this.P972 = currentParametroAluta["2"].P97;

      this.P33 = currentParametroAluta["3"].P3;
      this.P253 = currentParametroAluta["3"].P25;
      this.P503 = currentParametroAluta["3"].P50;
      this.P753 = currentParametroAluta["3"].P75;
      this.P973 = currentParametroAluta["3"].P97;

      this.P34 = currentParametroAluta["4"].P3;
      this.P254 = currentParametroAluta["4"].P25;
      this.P504 = currentParametroAluta["4"].P50;
      this.P754 = currentParametroAluta["4"].P75;
      this.P974 = currentParametroAluta["4"].P97;

      this.estaturaData0 = {
        labels: Array.from({ length: 26 }, (_, i) => `Semana ${i + 1}`),
        datasets: [
          {
            label: "P3",
            data: this.P30,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.P250,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.P500,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.P750,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.P970,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.puntos0,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.estaturaData1 = {
        labels: Array.from({ length: 26 }, (_, i) => `Semana ${i + 27}`),
        datasets: [
          {
            label: "P3",
            data: this.P31,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.P251,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.P501,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.P751,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.P971,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.puntos1,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.estaturaData2 = {
        labels: Array.from({ length: 24 }, (_, i) => `${i + 12} meses`),
        datasets: [
          {
            label: "P3",
            data: this.P32,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.P252,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.P502,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.P752,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.P972,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.puntos2,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.estaturaData3 = {
        labels: Array.from({ length: 12 }, (_, i) => `${i + 36} meses`),
        datasets: [
          {
            label: "P3",
            data: this.P33,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.P253,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.P503,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.P753,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.P973,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.puntos3,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.estaturaData4 = {
        labels: Array.from(
          { length: 20 },
          (_, i) => `${(i * 0.5 + 4).toFixed(1)} años`
        ),
        datasets: [
          {
            label: "P3",
            data: this.P34,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.P254,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.P504,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.P754,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.P974,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.puntos4,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      //PESOS

      const currentParametroPeso =
        this.paciente.sexo === "MASCULINO"
          ? this.parametrosPesoNino
          : this.parametrosPesoNina;
      this.PE30 = currentParametroPeso["0"].P3;
      this.PE250 = currentParametroPeso["0"].P25;
      this.PE500 = currentParametroPeso["0"].P50;
      this.PE750 = currentParametroPeso["0"].P75;
      this.PE970 = currentParametroPeso["0"].P97;

      this.PE31 = currentParametroPeso["1"].P3;
      this.PE251 = currentParametroPeso["1"].P25;
      this.PE501 = currentParametroPeso["1"].P50;
      this.PE751 = currentParametroPeso["1"].P75;
      this.PE971 = currentParametroPeso["1"].P97;

      this.PE32 = currentParametroPeso["2"].P3;
      this.PE252 = currentParametroPeso["2"].P25;
      this.PE502 = currentParametroPeso["2"].P50;
      this.PE752 = currentParametroPeso["2"].P75;
      this.PE972 = currentParametroPeso["2"].P97;

      this.PE33 = currentParametroPeso["3"].P3;
      this.PE253 = currentParametroPeso["3"].P25;
      this.PE503 = currentParametroPeso["3"].P50;
      this.PE753 = currentParametroPeso["3"].P75;
      this.PE973 = currentParametroPeso["3"].P97;

      this.PE34 = currentParametroPeso["4"].P3;
      this.PE254 = currentParametroPeso["4"].P25;
      this.PE504 = currentParametroPeso["4"].P50;
      this.PE754 = currentParametroPeso["4"].P75;
      this.PE974 = currentParametroPeso["4"].P97;

      this.pesoData0 = {
        labels: Array.from({ length: 26 }, (_, i) => `Semana ${i + 1}`),
        datasets: [
          {
            label: "P3",
            data: this.PE30,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.PE250,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.PE500,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.PE750,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.PE970,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.pesos0,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.pesoData1 = {
        labels: Array.from({ length: 26 }, (_, i) => `Semana ${i + 27}`),
        datasets: [
          {
            label: "P3",
            data: this.PE31,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.PE251,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.PE501,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.PE751,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.PE971,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.pesos1,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.pesoData2 = {
        labels: Array.from({ length: 24 }, (_, i) => `${i + 12} meses`),
        datasets: [
          {
            label: "P3",
            data: this.PE32,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.PE252,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.PE502,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.PE752,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.PE972,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.pesos2,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.pesoData3 = {
        labels: Array.from({ length: 12 }, (_, i) => `${i + 36} meses`),
        datasets: [
          {
            label: "P3",
            data: this.PE33,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.PE253,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.PE503,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.PE753,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.PE973,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.pesos3,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.pesoData4 = {
        labels: Array.from(
          { length: 20 },
          (_, i) => `${(i * 0.5 + 4).toFixed(1)} años`
        ),
        datasets: [
          {
            label: "P3",
            data: this.PE34,
            borderColor: "rgba(173, 216, 230, 1)",
            backgroundColor: "rgba(173, 216, 230, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P25",
            data: this.PE254,
            borderColor: "rgba(135, 206, 250, 1)",
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P50 (Mediana)",
            data: this.PE504,
            borderColor: "rgba(70, 130, 180, 1)",
            backgroundColor: "rgba(70, 130, 180, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P75",
            data: this.PE754,
            borderColor: "rgba(30, 144, 255, 1)",
            backgroundColor: "rgba(30, 144, 255, 0.1)",
            fill: false,
            tension: 0.3,
          },
          {
            label: "P97",
            data: this.PE974,
            borderColor: "rgba(0, 51, 102, 1)",
            backgroundColor: "rgba(0, 51, 102, 0.1)",
            fill: false,
            tension: 0.3,
          },

          {
            label: "Paciente",
            data: this.pesos4,
            borderColor: "red",
            backgroundColor: "red",
            showLine: true, // conecta los puntos
            fill: false,
            pointRadius: 5,
            pointStyle: "circle",
            tension: 0, // línea recta
          },
        ],
      };

      this.options = {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },
  },
};
</script>
<style scoped>
.graficos-dialog {
  min-height: 400px;
}
</style>
